import React, { useEffect, useState } from "react";
import { Card, Typography, Typography as typography_antd } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Box,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import styled from "@emotion/styled";
import bgImage from "../../assets/bgImage.png";
import { BarChart, PieChart, axisClasses } from "@mui/x-charts";
import "./dashboard.css";
import TodayIcon from "@mui/icons-material/Today";
import PeopleIcon from "@mui/icons-material/People";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CakeIcon from "@mui/icons-material/Cake";
import moment from "moment";
import { format, startOfMonth } from "date-fns/esm";
import env from "../../config/env";
import { toast } from "react-toastify";
import { fetchHolidayData } from "../../redux/slice/getHolidayData";
import { initializeUseSelector } from "react-redux/es/hooks/useSelector";
import { useDispatch, useSelector } from "react-redux";
import CelebrationIcon from "@mui/icons-material/Celebration";
import { fetchUserData } from "../../redux/slice/userData";
import { startOfYear } from "date-fns";
import { jwtDecode } from "jwt-decode";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import AddIcon from "@mui/icons-material/Add";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import axios from "axios";

const { Title } = typography_antd;

const DashboardStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",
  height: "100%",
});

const Dashboard = (props) => {
  let userName = props?.userData?.name;
  let userRole = props?.userData?.role_id;
  let userJoiningDate = props?.userData?.joining_date;
  const token = useSelector((state) => state.auth.token);
  let userId;

  if (token) {
    let decode = jwtDecode(token);
    userId = decode?.id;
  }

  let date = moment(new Date()).format("DD-MM-YYYY");
  const startMonth = new Date(userJoiningDate);
  const today_Date = new Date();
  const [greeting, setGreeting] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [age, setAge] = useState(10);
  const [disabledPunchIn, setDisabledPunchIn] = useState(false);
  const [disabledTakeBreak, setDisabledTakeBreak] = useState(false);
  const [disabledResuming, setDisabledResuming] = useState(false);
  const [disabledPunchOut, setDisabledPunchOut] = useState(false);
  const [disabledTempPunchOut, setDisabledTempPunchOut] = useState(false);
  const [startDate, setstartDate] = useState(format(startMonth, "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(today_Date, "yyyy-MM-dd"));
  const [isRunning, setIsRunning] = useState(false);
  const [time, setTime] = useState(0);
  const [toDetails, setToDetails] = useState([]);
  const [apiErr, setApiErr] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [openModalFinalPunchOut, setOpenModalFinalPunchOut] = useState(false);
  const [errorText, setErrorText] = useState({
    daily_update: "",
    commit: "",
    reason: "",
  });
  const [updateTempMsg, setUpdateTempMsg] = useState("");
  const [commit, setCommit] = useState("Yes");
  const [commitId, setCommitId] = useState("");
  const [reason, setReason] = useState("");
  const [upcomingEventsData, setUpcomingEventsData] = useState([]);
  const [genderData, setGenderData] = useState([
    { id: 0, value: 0, label: "Male" },
    { id: 1, value: 0, label: "Female", color: "#244DA0" },
  ]);
  const [lateInCount, setLateInCount] = useState(0);
  const [attendanceCount, setAttendanceCount] = useState(0);
  const [absentCount, setAbsentCount] = useState(0);
  const [applyLeaveCount, setApplyLeaveCount] = useState(0);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [earlyPunchOutMsg, setEarlyPunchOutMsg] = useState("");
  const [currentWorkingHrs, setCurrentWorkingHrs] = useState(0);

  let leaveData = []

  const dispatch = useDispatch();
  let userData = useSelector((state) => state.auth.userData);
  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [identityLoader, setIdentityLoader] = useState(false);
  const [profileLoader, setProfileLoader] = useState(false);
  const [profileImg, setProfileImg] = useState("");
  const [identityImg, setIdentityImg] = useState("");
  const [file, setFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [identityVal, setIdentityVal] = useState("");

  const [error, setError] = useState({
    profile_pic: "",
    identity_pic: "",
    aadhar_no: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    account_number: "",
    confirm_account_number: "",
    bank_ifsc: "",
    bank_name: "",
    branch_name: "",
  });

  const [profileData, setProfileData] = useState({
    profile_pic: userData.profile_pic ? userData.profile_pic : "",
    identity_pic: userData.identity_pic ? userData.identity_pic : "",
    aadhar_no: userData.aadhar_no ? userData.aadhar_no : "",
    first_name: userData.first_name ? userData.first_name : "",
    middle_name: userData.middle_name ? userData.middle_name : "",
    last_name: userData.last_name ? userData.last_name : "",
    account_number: userData.account_number ? userData.account_number : "",
    confirm_account_number: userData.account_number ? userData.account_number : "",
    bank_ifsc: userData.bank_ifsc ? userData.bank_ifsc : "",
    bank_name: userData.bank_name ? userData.bank_name : "",
    branch_name: userData.branch_name ? userData.branch_name : "",
  });


  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData) return;

    const isMissing = !userData.aadhar_no;

    if (!isMissing) return;

    const allowedPath = "/";

    // Block everything except EXACT allowed URL
    if (location.pathname !== allowedPath) {
      navigate(allowedPath, { replace: true });
    }

    // console.log(location.pathname, "kgjhjhds")
  }, [location.pathname, userData, navigate]);


  useEffect(() => {
    if (!userData) return;

    const isBankDetailsMissing =
      !userData.account_number ||
      !userData.bank_ifsc ||
      !userData.branch_name ||
      !userData.bank_name ||
      !userData.first_name ||
      !userData.middle_name ||
      !userData.last_name;

    const isProfileDetailsMissing =
      !userData.profile_pic ||
      !userData.aadhar_no ||
      !userData.identity_pic;

    // If salary > 0 → only check bank details
    if (userData.salary > 0) {
      if (isBankDetailsMissing) {
        setOpenProfileModal(true);
      }
    }

    if (isProfileDetailsMissing) {
      setOpenProfileModal(true);
    }
  }, [userData]);

  useEffect(() => {
    if (identityImg) {
      setIdentityLoader(false);
    }
  }, [identityImg]);

  useEffect(() => {
    if (profileImg) {
      setProfileLoader(false);
    }
  }, [profileImg]);

  const handleProfilePic = (event) => {
    const selectedFile = event.target.files[0];
    setProfileFile(selectedFile);
    setIdentityVal("Profile");
  };

  const handleIdentityPic = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setIdentityVal("Identity");
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (e.target.value !== "") {
      setProfileData({
        ...profileData,
        [name]: value,
      });
      setError({
        ...error,
        [name]: "",
      });
    } else {
      setProfileData({
        ...profileData,
        [name]: "",
      });
    }
  };

  // const validateFields = () => {
  //   let errorObj = {
  //     profile_pic: "",
  //     identity_pic: "",
  //     aadhar_no: "",
  //     first_name: "",
  //     middle_name: "",
  //     last_name: "",
  //     bank_name: "",
  //     account_number: "",
  //     confirm_account_number: "",
  //     bank_ifsc: "",
  //     branch_name: ""
  //   };


  //   if (!profileData.aadhar_no) {
  //     errorObj.aadhar_no = "Please enter your Adhar Card Number!";
  //   }

  //   if (profileData?.aadhar_no && !/^\d{12}$/.test(profileData?.aadhar_no)) {
  //     errorObj.aadhar_no = "Please input 12-digit Adhar Card Number";
  //   }

  //   if (!userData.profile_pic && !profileFile) {
  //     errorObj.profile_pic = "Please upload your Profile Image!";
  //   }

  //   if (!userData.identity_pic && !file) {
  //     errorObj.identity_pic = "Please upload your Identity Proof!";
  //   }

  //   if (!profileData.bank_ifsc) {
  //     errorObj.bank_ifsc = "Please enter a Bank IFSC Code!";
  //   }

  //   if (
  //     profileData.bank_ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(profileData.bank_ifsc)) {
  //     errorObj.bank_ifsc = "Please enter a proper Bank IFSC Code!";
  //   }

  //   if (!profileData.first_name) {
  //     errorObj.first_name = "Please enter a First Name";
  //   }

  //   if (!profileData.middle_name) {
  //     errorObj.middle_name = "Please enter a Middle Name";
  //   }

  //   if (!profileData.last_name) {
  //     errorObj.last_name = "Please enter a Last Name";
  //   }

  //   if (!profileData.bank_name) {
  //     errorObj.bank_name = "Please enter a Bank Name";
  //   }

  //   if (!profileData.account_number && !userData.account_number) {
  //     errorObj.account_number = "Please enter an Account Number";
  //   }

  //   if (profileData.account_number && !/^[0-9]{9,18}$/.test(profileData.account_number)) {
  //     errorObj.account_number = "Please enter a proper Account Nnumber!";
  //   }

  //   if (!profileData.confirm_account_number) {
  //     errorObj.confirm_account_number = "Please enter a confirm account Nnumber";
  //   }

  //   if (profileData.confirm_account_number !== profileData.account_number) {
  //     errorObj.confirm_account_number = "Please enter same account number!";
  //   }

  //   if (!profileData.branch_name) {
  //     errorObj.branch_name = "Please enter a Branch Nmae!";
  //   }

  //   setError({ ...errorObj });
  //   return !Object.values(errorObj).some((error) => error);
  // };

  const validateFields = () => {
    let errorObj = {
      profile_pic: "",
      identity_pic: "",
      aadhar_no: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      bank_name: "",
      account_number: "",
      confirm_account_number: "",
      bank_ifsc: "",
      branch_name: ""
    };

    // Profile & identity
    if (!userData.profile_pic && !profileFile) {
      errorObj.profile_pic = "Please upload your Profile Image!";
    }
    if (!userData.identity_pic && !file) {
      errorObj.identity_pic = "Please upload your Identity Proof!";
    }

    // Aadhar
    if (!profileData.aadhar_no && !userData.aadhar_no) {
      errorObj.aadhar_no = "Please enter your Aadhaar Card Number!";
    } else if (profileData.aadhar_no && !/^\d{12}$/.test(profileData.aadhar_no)) {
      errorObj.aadhar_no = "Please input 12-digit Aadhaar Card Number";
    }

    // Name fields
    if (userData.salary > 0) {
      if (!profileData.first_name && !userData.first_name) {
        errorObj.first_name = "Please enter a First Name";
      }
      if (!profileData.middle_name && !userData.middle_name) {
        errorObj.middle_name = "Please enter a Middle Name";
      }
      if (!profileData.last_name && !userData.last_name) {
        errorObj.last_name = "Please enter a Last Name";
      }

      // Bank info
      if (!profileData.bank_name && !userData.bank_name) {
        errorObj.bank_name = "Please enter a Bank Name";
      }

      if (!profileData.account_number && !userData.account_number) {
        errorObj.account_number = "Please enter an Account Number";
      } else if (profileData.account_number && !/^[0-9]{9,18}$/.test(profileData.account_number)) {
        errorObj.account_number = "Please enter a valid Account Number!";
      }

      if (!profileData.confirm_account_number && !userData.account_number) {
        errorObj.confirm_account_number = "Please enter a Confirm Account Number";
      } else if (profileData.confirm_account_number !== profileData.account_number) {
        errorObj.confirm_account_number = "Account numbers do not match!";
      }

      if (!profileData.bank_ifsc && !userData.bank_ifsc) {
        errorObj.bank_ifsc = "Please enter a Bank IFSC Code!";
      } else if (profileData.bank_ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(profileData.bank_ifsc)) {
        errorObj.bank_ifsc = "Please enter a valid Bank IFSC Code!";
      }

      if (!profileData.branch_name && !userData.branch_name) {
        errorObj.branch_name = "Please enter a Branch Name!";
      }
    }

    setError(errorObj);
    // console.log("Validation errors:", errorObj);
    return !Object.values(errorObj).some((error) => error);
  };

  let tempData = "";
  const handleFileUpload = async (fileData) => {
    const formData = new FormData();
    formData.append("file", fileData);

    await axios.post(`${env.backend_api_endpoint}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        tempData = response.data.filename;
      })
      .catch((error) => {
        // console.log(error.response.data.error);
      });
    return tempData
  };

  const onFinish = async () => {

    let profileImgUrl = '';
    let identityFileurl = '';

    // console.log(validateFields(), "hghbhdbh")

    if (validateFields()) {
      try {
        // if (profileFile !== null) {
        //   profileImgUrl = await handleFileUpload(profileFile)
        // }
        // if (file !== null) {
        //   identityFileurl = await handleFileUpload(file);
        // }

        // Profile image
        if (profileFile) {
          // user uploaded a new profile pic → upload it
          profileImgUrl = await handleFileUpload(profileFile);
        } else {
          // user didn't upload → keep old one
          profileImgUrl = userData.profile_pic;
        }

        // Identity image
        if (file) {
          // user uploaded a new identity proof → upload it
          identityFileurl = await handleFileUpload(file);
        } else {
          // user didn't upload → keep old one
          identityFileurl = userData.identity_pic;
        }

        try {

          const data = {
            // userId: location?.state?.id,
            personalEmail: userData.personalEmail,
            phoneNo: userData.phoneNo,
            alternateNo: userData.alternateNo,
            dob: userData.dob,
            address: userData.address,
            gender: userData.gender,
            profilePic: profileImgUrl,
            identityPic: identityFileurl,
            aadharNo: profileData?.aadhar_no,
            firstName: profileData?.first_name,
            middleName: profileData?.middle_name,
            lastName: profileData?.last_name,
            accountNumber: profileData?.account_number,
            bankIFSC: profileData?.bank_ifsc,
            bankName: profileData.bank_name,
            branchName: profileData?.branch_name
          }

          // console.log(data, "khudhubhs")

          // Encrypt data
          const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

          //Encrypt api endpoint
          const updateProfile = CryptoJS.SHA256("/updateProfile" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

          const response = await fetch(`${env.backend_api_endpoint}/${updateProfile}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            body: JSON.stringify({ encryptedData: encryptedBody }),
          });

          if (response.ok) {
            const successData = await response.json();
            if (successData.status === 200) {

              toast.success("Profile Updated successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });

              // console.log("Dispatching update:", {
              //   ...userData,
              //   aadhar_no: profileData?.aadhar_no,
              //   first_name: profileData?.first_name,
              //   middle_name: profileData?.middle_name,
              //   last_name: profileData?.last_name,
              //   account_number: profileData?.account_number,
              //   bank_ifsc: profileData?.bank_ifsc,
              //   bank_name: profileData.bank_name,
              //   branch_name: profileData?.branch_name
              // });

              // Update Redux state with merged user data
              dispatch(setUserData({
                ...userData,
                profile_pic: profileImgUrl,
                identity_pic: identityFileurl,
                aadhar_no: profileData?.aadhar_no,
                first_name: profileData?.first_name,
                middle_name: profileData?.middle_name,
                last_name: profileData?.last_name,
                account_number: profileData?.account_number,
                bank_ifsc: profileData?.bank_ifsc,
                bank_name: profileData.bank_name,
                branch_name: profileData?.branch_name
              }));

              setProfileData({
                profile_pic: "",
                identity_pic: "",
                aadhar_no: "",
                first_name: "",
                middle_name: "",
                last_name: "",
                account_number: "",
                confirm_account_number: "",
                bank_ifsc: "",
                bank_name: "",
                branch_name: ""
              });
              setOpenProfileModal(false)
            }
          }
          if (!response.ok) {
            const errorData = await response.json();

            if (errorData.status === 555 || errorData.status === 501) {
              dispatch(setToken(null));
              dispatch(setUserData(null));
              toast.error("Session expire, Please LogIn!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });
              Navigate("/login")
            }
          }
        } catch (error) {
          console.error("Error New User in:", error.message);
        }
      }
      catch (err) {
        console.error("error Upload API", err)
      }
    }
  }

  useEffect(() => {
    if (upcomingEventsData) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [upcomingEventsData]);

  useEffect(() => {
    if (userRole && token) {
      const obj = {
        roleId: userRole,
        token: token,
      };
      dispatch(fetchHolidayData(obj));
    }
  }, [token, userRole]);

  const state = useSelector((state) => state);
  // if(state?.getHoliday?.data?.status === 555 || state?.getHoliday?.data?.status === 501){
  //   dispatch(setToken(null));
  //   dispatch(setUserData(null));
  // toast.error("Session expire, Please LogIn!", {
  //   position: toast.POSITION.TOP_RIGHT,
  //   toastId: "1",
  // });
  //   Navigate("/login")
  // }

  let holidayData = state?.getHoliday?.data?.encryptedData;

  // console.log(holidayData, "holidayData")

  useEffect(() => {
    if (holidayData) {
      getAllEmployeeData();
      getEmployeeLeaveData();
    }

    // getAllEmployeeData();
    // getEmployeeLeaveData();

    if (token) {
      fetchAttendanceData();
    }
  }, [holidayData]);

  // useEffect(() => {
  //   if (token) {
  //     fetchAttendanceData();
  //     // getEmployeeLeaveData();
  //   }
  // }, [token])

  useEffect(() => {
    if (userName) {
      setEmployeeName(userName);
    }
  }, [userName]);

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const getEmployeeLeaveData = async () => {
    try {

      const getLeaves = CryptoJS.SHA256("/getLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      const encryptedVal = CryptoJS.AES.encrypt(userId.toString(), SECRET_KEY).toString();
      const encodedId = encodeURIComponent(encryptedVal); // ✅ very important

      const response = await fetch(`${env.backend_api_endpoint}/${getLeaves}?userId=${encodedId}&page=&limit=`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData?.status === 400) {
        }
        if (errorData?.status === 404) {
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login");
        }
        throw new Error("Error fetching attendance details");
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          // console.log(decryptedData, "ygyfhgv")

          let totalDays = 0;

          // Iterate over the leaves and sum up the 'days' property
          decryptedData.data.forEach((leave) => {
            if (leave.leave_status == "Approved" ||
              leave.leave_status == "Pending") {
              leaveData.push(leave);
            }
            if (
              leave.leave_status == "Approved" ||
              leave.leave_status == "Pending"
            ) {
              totalDays += leave.days;
            }
          });
          setApplyLeaveCount(totalDays);
          fetchAttendanceData();
        }
      }
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const getAllEmployeeData = async () => {
    try {

      const getEmployee = CryptoJS.SHA256("/getEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

      const response = await fetch(
        `${env.backend_api_endpoint}/${getEmployee}?name=&roleValue=`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 404) {
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login");
        }
      }
      if (response.ok) {

        const successData = await response.json();

        if (successData.status === 200 && successData.data) {

          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          let arr = [];
          let maleCount = 0;
          let femaleCount = 0;

          // Iterate through the data array
          decryptedData.forEach((user) => {
            // Check if gender is specified and count accordingly
            if (user?.gender) {
              if (user.gender && user.gender.toLowerCase() === "male") {
                maleCount++;
              }
              else if (user.gender && user.gender.toLowerCase() === "female") {
                femaleCount++;
              }
            }
          });

          setGenderData([
            { id: 0, value: maleCount, label: "Male" },
            { id: 1, value: femaleCount, label: "Female", color: "#244DA0", fontFamily: "MilliardMedium" },
          ]);

          const today = new Date();
          const currentYear = today.getFullYear();

          // Function to update the year to the current year
          const updateToCurrentYear = (date) => {
            const [year, month, day] = date?.split("-");
            return `${currentYear}-${month}-${day}`;
          };

          // console.log(decryptedData, "hvsdghvjhvs")

          decryptedData.map((val) => {
            if (val?.dob !== "0000-00-00" && val?.dob) {
              const tempDate = updateToCurrentYear(val.dob);
              arr.push({
                name: `${val?.name}'s BirthDay`,
                date: tempDate,
                event: false,
              });
              // console.log(arr, "arrrrrrrrr")
            }
          });


          holidayData?.map((holidayVal) => {
            arr.push({
              name: holidayVal?.holiday_title,
              date: holidayVal?.holiday_date,
              event: true,
            });
            // console.log(arr, "gjgysjgdvjyg")
          });

          // console.log(holidayData, "hoooooooooliiiiiiiiiidayyyyy")

          // Update birthdays and remove past events
          const updatedEvents = arr.filter((event) => {
            const eventDate = new Date(event.date);
            return eventDate >= today; // Keep only future or today’s events
          });

          // console.log(updatedEvents, "updatedEventsupdatedEventsupdatedEvents")

          // Sort by date
          updatedEvents.sort((a, b) => new Date(a.date) - new Date(b.date));

          setUpcomingEventsData(updatedEvents);
        }
      }
    } catch (error) {
      console.error("Error User in:", error.message);
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${hours.toString().padStart(2, "0")} Hr  ${minutes
      .toString()
      .padStart(2, "0")} Min  ${seconds.toString().padStart(2, "0")} Sec`;
  };

  const fetchAttendanceData = async () => {
    try {

      //Encrypt api endpoint
      const getAttendance = CryptoJS.SHA256("/getAttendance" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encodeURIComponent(encrypt)
      }

      const encryptedUserID = encryptData(userId)
      const encryptedStartDate = encryptData(startDate);
      const encryptedEndDate = encryptData(endDate);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getAttendance}?userId=${encryptedUserID}&startDate=${encryptedStartDate}&endDate=${encryptedEndDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      // console.log(response, "ressponseeeeeeeeeeee")
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData?.status === 400) {
        }
        if (errorData?.status === 404) {
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login");
        }
        throw new Error("Error fetching attendance details");
      }
      let data = [];
      data = await response.json();

      // console.log(data, "data");

      const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
      data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setDisabledPunchIn(false);
      setDisabledTakeBreak(false);
      setDisabledResuming(false);
      setDisabledPunchOut(false);
      setDisabledTempPunchOut(false);

      const entriesForCurrentDate = [data[0]?.data[data[0]?.data.length - 1]];

      // console.log(entriesForCurrentDate, "entriesForCurrentDateentriesForCurrentDateentriesForCurrentDate")

      if (entriesForCurrentDate.length > 0 && entriesForCurrentDate[0]?.date === endDate) {

        // Find the latest entry based on punch in time
        const latestEntry = entriesForCurrentDate.reduce((prev, current) => {
          return moment(current.punch_in, "DD-MM-YYYY HH:mm:ss").isAfter(
            moment(prev.punch_in, "DD-MM-YYYY HH:mm:ss")
          ) ? current : prev;
        });
        setToDetails(latestEntry);
        setAttendanceData([data[0]]);
        forTimmer(latestEntry, data);
        console.log(latestEntry, "latestEntrylatestEntrylatestEntry")
      }


      let lateIn = 0;
      let attendance = 0;
      const datesInRange = [];
      let currentDate = new Date(startDate);
      let eDate = new Date(endDate);

      while (currentDate <= eDate) {
        if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
          // If it's not Sunday or Saturday, add to the array
          datesInRange.push({ date: new Date(currentDate) });
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      // console.log(datesInRange, "datesInRangedatesInRangedatesInRange")


      const datesArray1 = datesInRange.map((item) => moment(item.date).format("DD-MM-YYYY")); // Extracting date part only
      const datesArray2 = data.map((item) => moment(item.date).format("DD-MM-YYYY"));
      const tempHoliday = holidayData.map((holidayItem) => moment(holidayItem.holiday_date).format("DD-MM-YYYY"));
      const holidyaDates = datesArray1.filter((date) => !datesArray2.includes(date));
      const datesNotInArray2 = holidyaDates.filter((date) => !tempHoliday.includes(date));

      // console.log(tempHoliday, "datesNotInArray2datesNotInArray2datesNotInArray2")

      const finalAbsentData = datesNotInArray2.filter((val) => {

        // Check if the date is within any leave range
        const isWithinLeave = leaveData.some((leaveItem) => {
          let tDate = moment(val, "DD-MM-YYYY").format("YYYY-MM-DD")

          let tempDate = new Date(tDate);
          const tempstartDate = new Date(leaveItem.start_date);
          const tempendDate = new Date(leaveItem.end_date);


          // Check if leave duration is 1 and date falls within the leave period
          if (leaveItem.leave_duration === 1) {
            return tempDate <= tempstartDate && tempDate >= tempendDate;
          }
          return false;
        });

        // If the date is NOT within any leave range, include it in finalAbsentData
        return !isWithinLeave;
      });

      setAbsentCount(finalAbsentData?.length);

      data?.forEach((val) => {
        const data1 = val?.data;
        // console.log(data1, "daatttttttttttttttttt1")
        if (
          data1[0].punch_in?.split(" ")[1].split(":")[0] >= 11 &&
          data1[0].punch_in?.split(" ")[1].split(":")[1] > 0
        ) {
          lateIn++;
        } else {
          attendance++;
        }
      });
      // console.log(lateIn, "lateInlateInlateInlateIn")
      setAttendanceCount(attendance);
      setLateInCount(lateIn);
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const forTimmer = (latestEntry, data) => {
    // current Time
    const time = new Date();
    const sencodsDate = moment(time);
    const timeInSeconds = sencodsDate.format("HH:mm:ss");
    const convertedTime = moment.duration(timeInSeconds);
    let totalCurrentSeconds = convertInSecond(convertedTime);

    // Punch in Time
    let punchInDate = new Date(latestEntry?.punch_in);
    let punchInTimeTemp = convertHH_MM_SS(punchInDate);
    punchInTimeTemp = moment.duration(punchInTimeTemp);
    let totalPunchInSeconds = convertInSecond(punchInTimeTemp);
    const forBreak =
      data[0]?.data[data[0]?.data.length - 1]?.break_hours === null
        ? 0
        : data[0]?.data[data[0]?.data.length - 1]?.break_hours;
    let totalTime =
      totalCurrentSeconds -
      totalPunchInSeconds -
      forBreak +
      data[0].totalWorkingHours;
    totalTime = Math.abs(totalTime);

    // For Break
    let tempArr =
      data[0]?.data[data[0]?.data.length - 1]?.break === null
        ? 0
        : data[0]?.data[data[0]?.data.length - 1]?.break;
    tempArr = JSON.parse(tempArr);
    let userBreakTime = convertNormalHH_MM_SS(
      tempArr[tempArr.length - 1]?.break_in
    );
    userBreakTime = moment.duration(userBreakTime);
    const totalbreakSeconds = convertInSecond(userBreakTime);
    let t2 = totalCurrentSeconds - totalbreakSeconds;
    let dbBreakTime = totalTime - t2;
    const tempdbBreakTime = Math.abs(dbBreakTime);
    let valdbBreakTime = formatSecondInTime(tempdbBreakTime);

    if (
      data[0]?.data[data[0]?.data.length - 1]?.punch_out === null &&
      data[0]?.data[data[0]?.data.length - 1]?.on_break === false
    ) {
      setTime(totalTime);
      setIsRunning(true);
    } else if (data[0]?.data[data[0]?.data.length - 1]?.on_break === true) {
      setIsRunning(false);
      setTime(tempdbBreakTime);
    } else {
      setTime(data[0]?.date === date ? data[0]?.totalWorkingHours : 0);
      setIsRunning(false);
    }
  };

  const convertHH_MM_SS = (dateTime) => {
    const hours = String(dateTime.getHours()).padStart(2, "0");
    const minutes = String(dateTime.getMinutes()).padStart(2, "0");
    const seconds = String(dateTime.getSeconds()).padStart(2, "0");
    return hours + ":" + minutes + ":" + seconds;
  };

  const convertNormalHH_MM_SS = (dateTime) => {
    const time1 = dateTime?.split(" ")[1]?.split(":")[0];
    const time2 = dateTime?.split(" ")[1]?.split(":")[1];
    const time3 = dateTime?.split(" ")[1]?.split(":")[2];
    return time1 + ":" + time2 + ":" + time3;
  };

  const convertInSecond = (hms) => {
    let temVal = hms.hours() * 3600 + hms.minutes() * 60 + hms.seconds();
    return temVal;
  };

  const formatSecondInTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Formatting each part to have leading zeros if necessary
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    const hour = new Date().getHours();
    let newGreeting = "";
    if (hour < 12) {
      newGreeting = "Good Morning";
    } else if (hour < 18) {
      newGreeting = "Good Afternoon";
    } else {
      newGreeting = "Good Evening";
    }
    setGreeting(newGreeting);
  }, []);

  const options = {
    weekday: "long",
    month: "long",
    day: "2-digit",
    year: "numeric",
  };

  const today = new Date().toLocaleDateString("en-US", options);
  const formattedDate = moment().format("dddd, DD MMMM YYYY");

  const handlePunchIn = async () => {
    setDisabledPunchIn(true);
    const message = "Punch In";

    if (employeeName !== "") {
      try {

        const punchIn = CryptoJS.SHA256("/punchIn" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(`${env.backend_api_endpoint}/${punchIn}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedMessage }),
        });

        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login");
          }
          throw new Error("Error punching in");
        }
        fetchAttendanceData();
      } catch (error) {
        // Handle error
        console.error("Error punching in:", error.message);
      }
    }
  };

  const handleTakeBreak = async () => {
    setDisabledTakeBreak(true);
    const message = "Taking Break";

    if (employeeName !== "") {
      try {

        const takeBreak = CryptoJS.SHA256("/takeBreak" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(`${env.backend_api_endpoint}/${takeBreak}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedMessage }),
        });
        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login");
          }
          throw new Error("Error taking a break");
        }
        fetchAttendanceData();
      } catch (error) {
        console.error("Error taking a break:", error.message);
      }
    }
  };

  const handleResumeBreak = async () => {
    setDisabledResuming(true);
    const message = "Resuming Work";
    if (employeeName !== "") {
      try {

        const resumeBreak = CryptoJS.SHA256("/resumeBreak" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(
          `${env.backend_api_endpoint}/${resumeBreak}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            body: JSON.stringify({ encryptedMessage }),
          }
        );
        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login");
          }
          throw new Error(errorData.error); // Throw the error message
        }
        fetchAttendanceData();
      } catch (error) {
        console.error("Error resuming:", error.message);
      }
    }
  };

  const handleCheckPunchOut = async () => {
    setDisabledTempPunchOut(true);
    if (employeeName !== "") {
      try {

        const checkPunchOut = CryptoJS.SHA256("/checkPunchOut" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(
          `${env.backend_api_endpoint}/${checkPunchOut}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            // body: JSON.stringify({ userId }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            setopenModal(false);
            if (errorData?.msg != "User already on braek")
              toast.error(`${errorData?.msg}!`, {
                position: toast.POSITION.BOTTOM_RIGHT,
                toastId: "1",
              });
            if (errorData?.data.on_break) {
              Modelhandler();
            }
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login");
          }

          throw new Error("Error punching out");
        }
        if (response.ok) {
          const errorData = await response.json();
          if (errorData?.status === 200) {
            let currentTimeHrs = Math.floor(time / 3600);
            setCurrentWorkingHrs(currentTimeHrs);
            setOpenModalFinalPunchOut(true);
          }
        }
      } catch (error) {
        console.error("Error punching out:", error.message);
      }
    }
  };

  const handlePunchOutConfirm = async () => {
    const commitOrReason = commit === "Yes" ? commitId : reason;

    if (
      updateTempMsg.trim() === "" ||
      commitOrReason.trim() === "" ||
      (earlyPunchOutMsg.trim() === "" && currentWorkingHrs < 8)
    ) {
      if (
        commit === "Yes" &&
        commitId.trim() === "" &&
        updateTempMsg.trim() === ""
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",
          commit: "Please Enter Your Commit ID!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "No" &&
        reason.trim() === "" &&
        updateTempMsg.trim() === ""
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",

          reason: "Please Enter Your  Code Commit Excuse!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        (updateTempMsg.trim() === "" &&
          commit === "Yes" &&
          commitId.trim() !== "") ||
        (commit === "No" && reason.trim() !== "")
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "Yes" &&
        commitId.trim() === "" &&
        updateTempMsg.trim() !== ""
      ) {
        setErrorText({
          ...errorText,
          commit: "Please Enter Your Commit ID!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "No" &&
        reason.trim() === "" &&
        updateTempMsg.trim() !== ""
      ) {
        setErrorText({
          ...errorText,
          reason: "Please Enter Your  Code Commit Excuse!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        earlyPunchOutMsg.trim() == "" &&
        ((commit === "Yes" &&
          commitId.trim() !== "" &&
          updateTempMsg.trim() !== "") ||
          (commit === "No" &&
            reason.trim() !== "" &&
            updateTempMsg.trim() !== ""))
      ) {
        setErrorText({
          ...errorText,
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
    } else {
      punchOut();
    }
  };

  const punchOut = async () => {
    setDisabledPunchOut(true);
    const message = "Punch Out";
    const codeCommit = commit === "Yes" ? true : false;
    const commitid = commitId === "" ? null : commitId.trim();
    const excuse = reason === "" ? null : reason.trim();
    const updateMsg = updateTempMsg.trim();
    const earlyLeaveReasonMsg = earlyPunchOutMsg.trim();
    if (employeeName !== "") {
      try {

        const data = {
          message,
          updateMsg,
          codeCommit,
          commitid,
          excuse,
          earlyLeaveReasonMsg,
        }

        const onbreakpunchOut = CryptoJS.SHA256("/onbreakpunchOut" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const encryptedResponse = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

        const response = await fetch(`${env.backend_api_endpoint}/${onbreakpunchOut}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedResponse }),
        });

        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login");
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            setopenModal(false);
            setCurrentWorkingHrs(0);
            setOpenModalFinalPunchOut(false);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          throw new Error("Error punching out");
        }
        fetchAttendanceData();
        setCurrentWorkingHrs(0);
        setopenModal(false);
        setOpenModalFinalPunchOut(false);
        setDisabledTempPunchOut(false);
        setUpdateTempMsg("");
        setEarlyPunchOutMsg("");
        setCommit("Yes");
        setCommitId("");
        setReason("");
      } catch (error) {
        console.error("Error punching out:", error.message);
        setopenModal(false);
        setOpenModalFinalPunchOut(false);
        setDisabledTempPunchOut(false);
      }
    }
  };

  const Modelhandler = () => {
    setopenModal(true);
  };

  const closeModel = () => {
    setopenModal(false);
  };

  let data = genderData ? genderData : [
    { id: 0, value: 0, label: "Male" },
    { id: 1, value: 0, label: "Female", color: "#244DA0" },
  ];

  return (
    <DashboardStyle>
      {!loading ? (
        <>
          <div className="dashboard_head display_flex justifyContent_spaceBetween align_item_center">

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Title level={3} className="text margin_zero" style={{ padding: "0px 8px 0px 0px" }}>
                {greeting}, {userName}
              </Title>
              <Title level={5} className="text margin_zero" >
                ({userData.emp_id})
              </Title>
            </div>

            <div className="display_flex align_item_center">
              <TodayIcon
                className="text"
                style={{
                  fontSize: "16px",
                  marginRight: "5px",
                  marginTop: "2px",
                }}
              />
              <span className="font_bold">{formattedDate}</span>
            </div>
          </div>

          <div className="section_a">
            <div>

              <div className="section_b">
                <Card bordered={false} id="card_design">
                  <div className=" align_item_center ">
                    <p className="font_bold font_size">{attendanceCount}</p>
                    <p className="text p_tag">Attendance</p>
                  </div>
                </Card>

                <Card bordered={false} id="card_design">
                  <div className="  align_item_center ">
                    <p className="font_bold font_size">{lateInCount}</p>
                    <p className="text p_tag">Late Coming</p>
                  </div>
                </Card>

                <Card bordered={false} id="card_design">
                  <div className="  align_item_center ">
                    <p className="font_bold font_size ">{absentCount}</p>
                    <p className="text p_tag">Absent</p>
                  </div>
                </Card>{" "}

                <Card bordered={false} id="card_design">
                  <div className=" align_item_center ">
                    <p className="font_bold font_size">{applyLeaveCount}</p>
                    <p className="text p_tag">Leave Apply</p>
                  </div>
                </Card>{" "}
              </div>

              <div style={{ width: "100%", marginTop: "20px" }}>
                <Card bordered={false} id="card_design">
                  <Title level={4} className="text">
                    Upcoming Events
                  </Title>

                  <TableContainer
                    component={Paper}
                    className="table-events"
                    style={{
                      borderTopLeftRadius: 15,
                      borderTopRightRadius: 15,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0
                    }}
                  >
                    <Table
                      aria-label="simple table"
                      sx={{
                        minWidth: 200,
                        '& th, & td': {
                          border: '1px solid #f0f0f0',
                        },
                      }}
                    >
                      <TableHead className="table_Header_color" sx={{ height: "50px" }}>
                        <TableRow
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#244DA0",
                          }}
                        >
                          <TableCell style={{ color: "white" }}>
                            Date
                          </TableCell>

                          <TableCell style={{ color: "white" }}>
                            Title
                          </TableCell>

                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {upcomingEventsData?.map((val) => {
                          const date = moment(val?.date);
                          const formattedDate = date.format("DD-MM-YYYY, dddd");
                          return (
                            <>
                              <TableRow
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell>{val?.name}</TableCell>
                                <TableCell>
                                  <div className="display_flex  align_item_center">
                                    {!val?.event && (
                                      <CakeIcon
                                        className="text"
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "5px",
                                          marginTop: "2px",
                                        }}
                                      />
                                    )}
                                    {val?.event && (
                                      <CelebrationIcon
                                        className="text"
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "5px",
                                          marginTop: "2px",
                                        }}
                                      />
                                    )}
                                    <span>{formattedDate}</span>
                                  </div>
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              </div>

            </div>

            <div>
              <div>
                <Card bordered={false} id="card_design">
                  <Title
                    level={4}
                    style={{
                      textAlign: "center",
                    }}
                    className="text"
                  >
                    Your Attendance
                  </Title>

                  <h3
                    style={{
                      textAlign: "center",
                      padding: "2% 0px",
                      color: "black",
                    }}
                  >
                    {formatTime(time)}
                  </h3>

                  <div
                    style={{
                      border: "1px solid gray",
                      padding: "10px",
                      borderRadius: "10px",
                      marginTop: "10px",
                      backgroundColor: "rgb(243 250 250)",
                      border: "none",
                    }}
                  >
                    <div className="display_flex justifyContent_spaceBetween align_item_center">
                      <span className="color_gray font_bold ">
                        Total Break Hours:
                      </span>

                      <span className="font_bold ">
                        {attendanceData?.map((val) =>
                          val?.totalBreakHours ? (
                            <>
                              {Math.floor(val?.totalBreakHours / 3600)} Hr{" "}
                              {Math.floor((val?.totalBreakHours % 3600) / 60)}{" "}
                              Min {Math.floor(val?.totalBreakHours % 60)} Sec{" "}
                            </>
                          ) : (
                            "0 Hr 0 Min 0 Sec"
                          )
                        )}
                      </span>
                    </div>

                    <div className="display_flex justifyContent_spaceBetween align_item_center margin_top_bottom">
                      <span className="color_gray font_bold ">
                        Total Working Hours:
                      </span>

                      <span className="font_bold ">
                        {attendanceData?.map((val) => (
                          <>
                            {val?.totalWorkingHours == null
                              ? "0 Hr 0 Min 0 Sec"
                              : `${Math.floor(
                                val?.totalWorkingHours / 3600
                              )} Hr  ${Math.floor(
                                (val?.totalWorkingHours % 3600) / 60
                              )} Min ${Math.floor(
                                val?.totalWorkingHours % 60
                              )} Sec`}
                          </>
                        ))}
                      </span>

                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      marginTop: "15px",
                    }}
                  >
                    {toDetails?.length !== 0 &&
                      toDetails?.on_break == 0 &&
                      toDetails?.punch_out === null && (
                        <LoadingButton
                          id="assign_leave"
                          size="large"
                          onClick={handleTakeBreak}
                          loading={disabledTakeBreak}
                          variant="contained"
                          style={{
                            backgroundColor: "orange",
                            borderRadius: "6px",
                            color: "white",
                            fontWeight: "500",
                            borderColor: "#244DA0",
                            textTransform: "none",
                            height: "44px",
                            width: "160px",
                            fontFamily: "MilliardMedium"
                          }}
                        >
                          <span> {disabledTakeBreak ? "" : "Take Break"}</span>
                        </LoadingButton>
                      )}

                    {toDetails?.length !== 0 && toDetails?.on_break == 1 && (
                      <LoadingButton
                        id="assign_leave"
                        size="large"
                        onClick={handleResumeBreak}
                        loading={disabledResuming}
                        variant="contained"
                        style={{
                          backgroundColor: "#0fa297",
                          borderRadius: "6px",
                          color: "white",
                          fontWeight: "500",
                          borderColor: "#244DA0",
                          textTransform: "none",
                          height: "44px",
                          width: "160px",
                          fontFamily: "MilliardMedium"
                        }}
                      >
                        <span>{disabledResuming ? "" : "Resuming"}</span>
                      </LoadingButton>
                    )}

                    {toDetails?.length !== 0 &&
                      toDetails?.punch_out === null && (
                        <LoadingButton
                          size="large"
                          onClick={handleCheckPunchOut}
                          loading={disabledTempPunchOut}
                          variant="contained"
                          style={{
                            backgroundColor: "red ",
                            borderRadius: "6px",
                            color: "white",
                            fontWeight: "500",
                            borderColor: "#244DA0",
                            height: "44px",
                            textTransform: "none",
                            width: "160px",
                            fontFamily: "MilliardMedium"
                          }}
                        >
                          <span>{disabledTempPunchOut ? "" : "Punch Out"}</span>
                        </LoadingButton>
                      )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "0px",
                    }}
                  >
                    {(toDetails.length == 0 ||
                      toDetails.punch_out !== null) && (
                        <LoadingButton
                          id="assign_leave"
                          size="large"
                          onClick={handlePunchIn}
                          loading={disabledPunchIn}
                          variant="contained"
                          style={{
                            backgroundColor: "#244DA0",
                            borderRadius: "6px",
                            color: "white",
                            fontWeight: "500",
                            borderColor: "#244DA0",
                            textTransform: "none",
                            height: "44px",
                            marginLeft: "10px",
                            width: "160px",
                            fontFamily: "MilliardMedium"
                          }}
                        >
                          <span style={{ display: "flex", alignItems: "center" }}>
                            {" "}
                            {disabledPunchIn ? (
                              ""
                            ) : (
                              <>
                                <FingerprintIcon style={{ marginRight: "5px" }} />
                                Punch In
                              </>
                            )}
                          </span>
                        </LoadingButton>
                      )}
                  </div>
                </Card>
              </div>

              <div style={{ width: "100%", marginTop: "20px" }}>
                <Card
                  bordered={false}
                  id="card_design"
                  style={{ height: "100%", }}
                >
                  <Title
                    level={4}
                    style={{
                      color: "#244DA0",
                      fontFamily: "ImportedMilliardBold",
                      textAlign: "center",
                    }}
                  >
                    Gender By Employess
                  </Title>

                  <div
                    className=" display_flex justifyContent_center"
                    style={{ padding: "10px 0 0 0 " }}
                  >
                    <PieChart
                      series={[
                        {
                          data,
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            innerRadius: 30,
                            additionalRadius: -30,
                            color: "gray",
                          },
                        },
                      ]}
                      height={180}
                      sx={{ fontFamily: "MilliardMedium" }}
                    />
                  </div>
                </Card>
              </div>
            </div>

          </div>
        </>
      ) : (
        <span class="loader"></span>
      )
      }
      <Dialog open={openModal}>
        <DialogContent>
          <center>
            <ErrorIcon style={{ fontSize: "50px" }} />
          </center>
          <p
            style={{
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "center",
              marginTop: "15px",
              color: " rgba(0, 0, 0, 0.66)",
            }}
          >
            You are on Break
          </p>
          <p
            style={{
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "center",
              marginTop: "15px",
              color: " rgba(0, 0, 0, 0.66)",
            }}
          >
            Are you sure want to Punch Out?
          </p>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "10px" }}
        >
          <Button
            block
            size="large"
            key="submit"
            type="primary"
            onClick={closeModel}
            style={{
              backgroundColor: "#E20E0E",
              borderRadius: "6px",
              color: "white",
              fontWeight: "500",
              borderColor: "#E20E0E",
              textTransform: "none",
              width: "120px",
            }}
          >
            No
          </Button>
          <Button
            size="large"
            block
            key="back"
            id="btndelete"
            style={{
              backgroundColor: "#244DA0",
              borderRadius: "6px",
              fontWeight: "500",
              borderColor: "#244DA0",
              color: "white",
              textTransform: "none",
              width: "120px",
            }}
            onClick={() => {
              let currentTimeHrs = Math.floor(time / 3600);
              setCurrentWorkingHrs(currentTimeHrs);
              setOpenModalFinalPunchOut(true);
              closeModel();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Final PunchOut Dialog */}
      <Dialog open={openModalFinalPunchOut} fullWidth>
        <div className="final_punchout_dialog">
          <DialogContent>
            <div>
              <Title
                level={3}
                style={{
                  color: "#244DA0",
                  fontFamily: "ImportedMilliardBold",
                }}
              >
                Task Report
              </Title>
              {currentWorkingHrs < 8 ? (
                <div>
                  <Typography className="label_text_final_punchout_dialog">
                    Reason for Early Punch Out{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    placeholder="Enter Reason for Early Punch Out"
                    fullWidth
                    multiline
                    rows={3}
                    autoComplete="off"
                    value={earlyPunchOutMsg}
                    onChange={(e) => {
                      setEarlyPunchOutMsg(e.target.value);
                      if (e.target.value.trim() !== "") {
                        setErrorText({
                          ...errorText,
                          early_leave_reason: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          early_leave_reason:
                            "Please Enter Your Reason for early Punch Out!",
                        });
                      }
                    }}
                    error={errorText.early_leave_reason}
                    helperText={errorText.early_leave_reason}
                  />
                </div>
              ) : null}
              <div>
                <Typography className="label_text_final_punchout_dialog">
                  End of Day Report <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  placeholder="Enter End of Day Report"
                  fullWidth
                  multiline
                  rows={3}
                  autoComplete="off"
                  value={updateTempMsg}
                  onChange={(e) => {
                    setUpdateTempMsg(e.target.value);
                    if (e.target.value.trim() !== "") {
                      setErrorText({
                        ...errorText,
                        daily_update: "",
                      });
                    } else {
                      setErrorText({
                        ...errorText,
                        daily_update: "Please Enter Your End of Day Report!",
                      });
                    }
                  }}
                  error={errorText.daily_update}
                  helperText={errorText.daily_update}
                />
              </div>
              <div>
                <Typography className="label_text_final_punchout_dialog">
                  Code Committed <span style={{ color: "red" }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue={commit}
                  onChange={(e) => {
                    setCommit(e.target.value);
                    setCommitId("");
                    setReason("");
                  }}
                >
                  <FormControlLabel
                    key="Yes"
                    value="Yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    key="No"
                    value="No"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </div>
            </div>
            <div>
              {commit === "Yes" ? (
                <>
                  <Typography className="label_text_final_punchout_dialog ">
                    Commit ID <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <TextField
                    placeholder="Enter Your Commit ID"
                    value={commitId}
                    fullWidth
                    autoComplete="off"
                    onChange={(e) => {
                      setCommitId(e.target.value);
                      if (e.target.value.trim() !== "") {
                        setErrorText({
                          ...errorText,
                          commit: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          commit: "Please Enter Your Commit ID!",
                        });
                      }
                    }}
                    error={errorText.commit}
                    helperText={errorText.commit}
                  />
                </>
              ) : (
                <>
                  <Typography className="label_text_final_punchout_dialog ">
                    Code Commit Excuse <span style={{ color: "red" }}>*</span>{" "}
                  </Typography>
                  <TextField
                    placeholder="Enter Your Code Commit Excuse"
                    value={reason}
                    fullWidth
                    autoComplete="off"
                    onChange={(e) => {
                      setReason(e.target.value);
                      if (e.target.value.trim() !== "") {
                        setErrorText({
                          ...errorText,
                          reason: "",
                        });
                      } else {
                        setErrorText({
                          ...errorText,
                          reason: "Please Enter Your  Code Commit Excuse!",
                        });
                      }
                    }}
                    error={errorText.reason}
                    helperText={errorText.reason}
                  />
                </>
              )}
            </div>
          </DialogContent>
          <DialogActions
            style={{ justifyContent: "space-evenly", marginBottom: "10px" }}
          >
            <Button
              block
              size="large"
              key="submit"
              type="primary"
              onClick={() => {
                setDisabledTempPunchOut(false);
                setUpdateTempMsg("");
                setCommitId("");
                setReason("");
                setEarlyPunchOutMsg("");
                setCurrentWorkingHrs(0);
                setOpenModalFinalPunchOut(false);
              }}
              style={{
                backgroundColor: "#E20E0E",
                borderRadius: "6px",
                color: "white",
                fontWeight: "500",
                borderColor: "#E20E0E",
                textTransform: "none",
                height: "44px",

                width: "130px",
              }}
            >
              Cancel
            </Button>

            <LoadingButton
              size="large"
              onClick={handlePunchOutConfirm}
              loading={disabledPunchOut}
              block
              key="back"
              id="btndelete"
              variant="contained"
              style={{
                backgroundColor: "#244DA0",
                borderRadius: "6px",
                fontWeight: "500",
                borderColor: "#244DA0",
                color: "white",
                textTransform: "none",
                height: "44px",

                width: "130px",
              }}
            >
              <span>{disabledPunchOut ? "" : "Confirm"} </span>
            </LoadingButton>
          </DialogActions>
        </div>
      </Dialog>

      <Modal open={openProfileModal} disableEscapeKeyDown>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            width: "65vw",          // wider view
            maxWidth: 1200,         // limit for very large screens
            height: "70vh",         // moderate height (landscape)
            overflow: "auto",       // enable scroll if content exceeds height
            p: 3,
            gap: 2,
          }}
        >
          <Box>
            <h2 style={{ margin: 0, color: "#244DA0" }}>Complete Your Profile</h2>
          </Box>


          {/* LEFT SIDE (preview / info panel) */}
          <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, marginTop: 2 }}          >
            <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
              {(userData.salary > 0 && (userData.first_name == "" || userData.first_name == null)) && (
                <TextField
                  name="first_name"
                  label="First Name"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.first_name}
                  helperText={error.first_name || ""}
                />
              )}

              {(userData.salary > 0 && (userData.middle_name == "" || userData.middle_name == null)) && (
                <TextField
                  name="middle_name"
                  label="Middle Name"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.middle_name}
                  helperText={error.middle_name || ""}
                />
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
              {(userData.salary > 0 && (userData.last_name == "" || userData.last_name == null)) && (
                <TextField
                  name="last_name"
                  label="Last Name"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.last_name}
                  helperText={error.last_name || ""}
                />
              )}
              {(userData.salary > 0 && (userData.bank_name == "" || userData.bank_name == null)) && (
                <TextField
                  name="bank_name"
                  label="Bank Name"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.bank_name}
                  helperText={error.bank_name || ""}
                />
              )}
            </div>

            {(userData.salary > 0 && (userData.account_number == "" || userData.account_number == null)) && (
              <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
                <TextField
                  name="account_number"
                  label="Account Number"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.account_number}
                  helperText={error.account_number || ""}
                />

                <TextField
                  name="confirm_account_number"
                  label="Confirm Account Number"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.confirm_account_number}
                  helperText={error.confirm_account_number || ""}
                />
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
              {(userData.salary > 0 && (userData.bank_ifsc == "" || userData.bank_ifsc == null)) && (
                <TextField
                  name="bank_ifsc"
                  label="Bank IFSC"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.bank_ifsc}
                  helperText={error.bank_ifsc || ""}
                />
              )}

              {(userData.salary > 0 && (userData.branch_name == "" || userData.branch_name == null)) && (
                <TextField
                  name="branch_name"
                  label="Branch Name"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.branch_name}
                  helperText={error.branch_name || ""}
                />
              )}
            </div>

            <div>

              {(userData.aadhar_no == "" || userData.aadhar_no == null) && (
                <TextField
                  name="aadhar_no"
                  label="Aadhar Card Number"
                  fullWidth
                  size="small"
                  onChange={handleFormChange}
                  error={!!error.aadhar_no}
                  helperText={error.aadhar_no || ""}
                />
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
              {(userData.profile_pic == "" || userData.profile_pic == null) && (
                <>
                  <Typography className="label_text_profile">
                    Upload Profile Picture <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <label
                    htmlFor="upload-photo"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "fit-content",
                    }}
                  >
                    <input
                      id="upload-photo"
                      name="upload-photo"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleProfilePic}
                    />
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "50%",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {!profileLoader ? (
                        profileFile ? (
                          <img
                            src={URL.createObjectURL(profileFile)}
                            alt="profile"
                            style={{
                              height: "50px",
                              width: "50px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <AddIcon />
                        )
                      ) : (
                        <CircularProgress size={30} />
                      )}
                    </div>
                  </label>
                  <FormHelperText sx={{ color: "#d32f2f" }}>
                    {error?.profile_pic}
                  </FormHelperText>
                </>
              )}

              {/* Identity Proof */}
              {(userData.identity_pic == "" || userData.identity_pic == null) && (
                <>
                  <Typography className="label_text_profile" sx={{ mt: 2 }}>
                    Upload Identity Proof <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <label htmlFor="upload-identity-photo" style={{ width: "fit-content" }}>
                    <input
                      id="upload-identity-photo"
                      name="upload-identity-photo"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleIdentityPic}
                    />
                    <div
                      style={{
                        backgroundColor: "#244DA0",
                        padding: "8px 15px",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: 6,
                      }}
                    >
                      <FileUploadIcon sx={{ mr: 1 }} /> Upload File
                    </div>
                  </label>

                  {!identityLoader && file ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="identity"
                      style={{
                        height: "65px",
                        width: "90px",
                        // marginTop: "10px",
                        objectFit: "cover",
                      }}
                    />
                  ) : identityLoader ? (
                    <CircularProgress sx={{ mt: 1 }} />
                  ) : null}

                  <FormHelperText sx={{ color: "#d32f2f" }}>
                    {error.identity_pic}
                  </FormHelperText>
                </>
              )}

            </div>


            {/* </Box> */}
            {/* RIGHT SIDE (form area) */}
            {/* <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, overflowY: "auto" }}> */}

            <Button
              size="large"
              variant="contained"
              sx={{
                alignSelf: "end",
                // mt: 2,
                backgroundColor: "#244DA0",
                textTransform: "none",
                borderRadius: "8px",
                fontFamily: "MilliardMedium",
                width: "200px",
              }}
              onClick={onFinish}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>

    </DashboardStyle >
  );
};

export default Dashboard;